import ApplicationItemView from './ApplicationItemView.html';
import { ApplicationItemController } from './ApplicationItemController';
export const ApplicationItemComponent = {
    controller: ApplicationItemController,
    controllerAs: '$ctrl',
    template: ApplicationItemView,
    bindings: {
        application: '<',
        chatbots: '<',
        onSave: '&',
        onExclude: '&',
        onEdit: '&?',
        singleForm: '&?',
    },
};
